import { sqliteTable, text, integer, index } from "drizzle-orm/sqlite-core";

// ============================================================================
// journal_entries — สมุดรายวัน
// ============================================================================
export const journalEntries = sqliteTable("accounting_journal_entries", {
  id: text("id").primaryKey(), // ULID
  entryNo: text("entry_no").notNull().unique(),
  companyId: text("company_id").notNull(),
  branchId: text("branch_id"),
  entryDate: text("entry_date").notNull(),
  entryType: text("entry_type", {
    enum: ["manual", "auto"],
  }).notNull(),
  referenceModule: text("reference_module"),
  referenceDoctype: text("reference_doctype"),
  referenceId: text("reference_id"),
  remarks: text("remarks"),
  docStatus: integer("doc_status").notNull().default(0), // 0=Draft, 1=Submitted, 2=Cancelled
  status: text("status", {
    enum: ["draft", "submitted", "cancelled"],
  })
    .notNull()
    .default("draft"),
  createdBy: text("created_by"),
  createdAt: text("created_at").notNull(),
  updatedAt: text("updated_at").notNull(),
  updatedBy: text("updated_by"),
  deletedAt: text("deleted_at"),
  deletedBy: text("deleted_by"),
}, (table) => ({
  companyStatusIdx: index("je_company_status_idx").on(table.companyId, table.status, table.entryDate),
  companyBranchIdx: index("je_company_branch_idx").on(table.companyId, table.branchId),
}));

// Type exports
export type JournalEntry = typeof journalEntries.$inferSelect;
export type NewJournalEntry = typeof journalEntries.$inferInsert;
